module.exports = __webpack_public_path__ + "img/cliu1.82e221c8.png";